import { useEffect, useRef } from 'react';
import AppLayoutNoticesTrial from './AppLayoutNoticesTrial';
import AppLayoutNoticesInvitations from './AppLayoutNoticesInvitations';
import AppLayoutNoticesProviderConnections from './AppLayoutNoticesProviderConnections';
import AppLayoutNoticesBankOutages from './AppLayoutNoticesBankOutages';
import AppLayoutNoticesFakeData from './AppLayoutNoticesFakeData.jsx';
import { Slot } from 'nano-slots';
import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';
import AppLayoutNoticesConnectBank from './AppLayoutNoticesConnectBank.jsx';
import { useEventDispatcher } from 'Components/Organisms/EventDispatcherContext';
import { APP_NOTICES_RESIZE } from 'Utils/eventTypes';

export default function AppLayoutNotices({ className }) {
    const ref = useRef(null);
    const eventDispatcher = useEventDispatcher();

    useEffect(() => {
        if (!ref.current) return;

        const resizeObserver = new ResizeObserver((entries) => {
            window.requestAnimationFrame(() => {
                if (!Array.isArray(entries) || entries.length === 0) return;

                eventDispatcher.dispatch(APP_NOTICES_RESIZE);
            });
        });

        resizeObserver.observe(ref.current);

        return () => {
            resizeObserver.disconnect();
        };
    }, [eventDispatcher]);

    return (
        <div ref={ref} className={cn('grid gap-[1px]', className)}>
            <AppLayoutNoticesTrial />
            <AppLayoutNoticesInvitations />
            <AppLayoutNoticesBankOutages />
            <AppLayoutNoticesProviderConnections />
            <AppLayoutNoticesFakeData />
            <AppLayoutNoticesConnectBank />
            <Slot name="app-notices" />
        </div>
    );
}

AppLayoutNotices.propTypes = {
    className: PropTypes.string,
};
